module.exports = __webpack_public_path__ + "static/media/29EUNOG14.73b8cc8d.jpg";